import {
  signUp,
  signIn,
  signOut,
  confirmSignUp,
  resetPassword,
  confirmResetPassword,
  getCurrentUser,
  fetchAuthSession,
} from 'aws-amplify/auth';

export async function register(email, password) {
  return signUp({
    username: email,
    password,
    options: { userAttributes: { email } },
  });
}

export async function verify(email, code) {
  return confirmSignUp({ username: email, confirmationCode: code });
}

export async function login(email, password) {
  return signIn({ username: email, password });
}

export async function requestPasswordReset(email) {
  return resetPassword({ username: email });
}

export async function confirmPasswordReset(email, code, newPassword) {
  return confirmResetPassword({
    username: email,
    confirmationCode: code,
    newPassword,
  });
}

export async function logout() {
  return signOut();
}

export async function getUser() {
  try {
    return await getCurrentUser();
  } catch {
    return null;
  }
}

export async function getToken() {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString();
  } catch {
    return null;
  }
}
